module.exports = __webpack_public_path__ + "img/perry-pocket.27bf968f.jpg";